import React from "react"
import AllFaqs from "./components/AllFaqs"
import FaqsHero from "./components/FaqsHero"
import "./faqs.css"

const FAQs = () => {
  return (
    <div>
      <FaqsHero/>
      <AllFaqs/>
    </div>
  )
}

export default FAQs